import '../../../../vendor/angular-ui-bootstrap/src/bindHtml/bindHtml.js';

export const uiBootstrapBindHtmlModule = 'ui.bootstrap.bindHtml';
